var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSzeneSpeichern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Szene-Speichern__Icn/40px/Szene-Speichern-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Szene-Speichern__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Szene-Speichern__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Szene-Speichern__Group",
    transform: "matrix(-1 0 0 1 34.997 8.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0092376,0.000230674037 L19.0728568,0.00294973382 C19.0898284,0.00427015099 19.1070096,0.00602706257 19.1240894,0.00822599687 C19.1420293,0.0106224568 19.1603673,0.0135352595 19.1787144,0.0169860869 L19.2326138,0.0284155567 L19.2993841,0.047 L19.3913034,0.0819320461 L26.3913034,3.08193205 C26.7589873,3.23951084 26.9973841,3.60104897 26.9973841,4.00107708 L26.9973841,19.0010771 C26.9973841,19.7189925 26.2633333,20.2030229 25.6034648,19.9202221 L18.9723841,17.078 L12.0413841,19.677 L12.0413841,17.541 L17.9973841,15.3070771 L17.9973841,2.44407708 L11.9973841,4.69407708 L11.9973841,13.457 L9.99738413,11.466 L9.99738413,4.66007708 L4.99738413,2.51707708 L4.99738413,6.576 L2.99738413,8.638 L2.99738413,1.00107708 C2.99738413,0.283161622 3.73143501,-0.200868706 4.39130343,0.0819320461 L11.0213841,2.923 L18.6462607,0.0647478985 L18.6765586,0.053460597 C18.6995649,0.0455952142 18.7228908,0.0385541905 18.746492,0.0323667022 L18.7263841,0.038 L18.7876078,0.0229887855 C18.8104183,0.0175498878 18.8338681,0.0133176823 18.8575133,0.00993308182 L18.8980604,0.00531758538 C18.9186858,0.00288954179 18.9398664,0.00142457436 18.9611535,0.000649600075 L19.0092376,0.000230674037 Z M19.9973841,2.51707708 L19.9973841,15.3410771 L24.9973841,17.4840771 L24.9973841,4.66007708 L19.9973841,2.51707708 Z",
    id: ".._.._src_svg_Icn_40px_Szene-Speichern__Combined-Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00261587,11.0010771 L6.002,19.5690771 L8.48528137,17.0868635 L9.89949494,18.5010771 L4.94974747,23.4508245 L2.17751154e-16,18.5010771 L1.41421356,17.0868635 L4.002,19.6750771 L4.00261587,11.0010771 L6.00261587,11.0010771 Z",
    id: ".._.._src_svg_Icn_40px_Szene-Speichern__Combined-Shape-Copy-2",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 34.452)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzeneSpeichern);
export default __webpack_public_path__ + "static/media/Szene-Speichern.2bf20b3b2eeb106698d523fd9f84e10f.svg";
export { ForwardRef as ReactComponent };